// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__vDBPO","small":"Logo_small__s0Vuc","medium":"Logo_medium__orAUa","large":"Logo_large__xuz7y"};